export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://manage-care-server.herokuapp.com';
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || 'https://manage-care-server.herokuapp.com/login';
export const AUTH_URL = process.env.REACT_APP_AUTH_URL || 'https://manage-care-server.herokuapp.com/auth';

// local development environment values
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';
// export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || 'http:/localhost:8080/login';
// export const AUTH_URL = process.env.REACT_APP_AUTH_URL || 'http://localhost:8080/auth';


// WEBPACK FOOTER //
// ./src/config.js